import {
    gridGutter,
    gridGutterHalf,
    fontSizeBase
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from "../../../../js/shared/new-theme";

export const defaultStyle = `
    background: ${theme.palette.common.white};
    border-top: 1px solid ${theme.palette.gray[400].value};
    border-bottom: 1px solid ${theme.palette.gray[400].value};
    margin-bottom: ${gridGutter}px;
    & + & {
        margin-top: -25px;
    }
    h6 {
        color: ${theme.palette.gray[800].value};
        font-size: ${fontSizeBase};
    }
`;

export const accordionHeaderStyle = (isOpen, hasError) => `
    display: flex;
    margin-bottom: ${isOpen ? gridGutterHalf : 0}px;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: ${gridGutter}px 0;
    color: ${hasError ? theme.palette.red[500].value : theme.palette.gray[600].value};
`;

export const accordionIconStyle = isOpen => `
    color: ${theme.palette.gray[600].value};
    transition: all 0.2s ease;
    transform: ${`rotate(${isOpen ? "180deg" : "0"})`};
`;
